<template>
  <v-card class="ma-4" elevation="0">
    <v-card-title>Historial de Solicitudes</v-card-title>
    <v-card-text>
      <v-row>
        <v-col>
          <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            clearable
            label="Escribe para filtrar"
            dense
            @keyup="onKeyup"
            @click:clear="clearSearch"
          />
        </v-col>
        <v-col>
          <v-select
            v-model="statusId"
            :items="customerstatus"
            item-text="status"
            item-value="id"
            label="Selecciona el status para filtrar"
            dense
            clearable
            @change="filterStatus"
          />
        </v-col>
        <v-col cols="12" md="3">
          <v-btn color="success" @click="requestExportAndNotify">
            Exportar Excel
          </v-btn>
        </v-col>
      </v-row>
      <iel-table :headers="headers">
        <tr v-if="requests.length <= 0">
          <iel-table-cell :cols="10"> No hay registros </iel-table-cell>
        </tr>
        <tr v-for="request in requests" :key="`request-${request.id}`">
          <iel-table-cell>{{ request.channel }}</iel-table-cell>

          <iel-table-cell>{{ request.custumer_code }}</iel-table-cell>

          <iel-table-cell>
            <a
              :href="`${url}/customersfiles/${request.id}/envelope`"
              target="_blank"
              >{{ request.envelope_id }}</a
            >
          </iel-table-cell>

          <iel-table-cell>{{ request.person_type }}</iel-table-cell>

          <iel-table-cell>{{ request.created_at }}</iel-table-cell>

          <iel-table-cell>{{ request.company_name }}</iel-table-cell>

          <iel-table-cell>{{ request.rfc }}</iel-table-cell>

          <iel-table-cell>{{ request.a_estate }}</iel-table-cell>

          <iel-table-cell>
            <v-chip
              v-if="request.customer_status.status == 'Revisión Crédito'"
              class="ma-2"
              color="primary"
              small
            >
              {{ request.customer_status.status }}
            </v-chip>
            <v-chip v-else class="ma-2" small>
              {{ request.customer_status.status }}
            </v-chip>
          </iel-table-cell>

          <iel-table-cell>
            <v-btn small icon type="success" @click="goToDetail(request.id)">
              <v-icon>mdi-eye</v-icon>
            </v-btn>
            <v-btn small icon @click="confirmResendEmail(request)">
              <v-icon>mdi-send</v-icon>
            </v-btn>
          </iel-table-cell>
        </tr>
      </iel-table>
      <div class="text-center my-2">
        <v-pagination v-model="pagination.page" :length="pagination.to" />
      </div>
    </v-card-text>

    <v-dialog v-model="showResendModal" max-width="500" persistent>
      <v-card>
        <v-card-title class="text-h6">
          ¿Deseas reenviar el correo de Docusign?
        </v-card-title>
        <v-card-text>
          Se enviará un correo a la dirección registrada en el cliente.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" text @click="closeResendModal"> Cancelar </v-btn>
          <v-btn
            color="primary"
            text
            :loading="resendLoading"
            @click="onConfirmResendEmail"
          >
            Sí, reenviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
  import { debounce } from '@/utilities/helpers';
  import IelTable from '@/components/tables/IElTable.vue';
  import IelTableCell from '@/components/tables/IELTableCell.vue';
  import { mapActions, mapGetters, mapMutations } from 'vuex';

  export default {
    name: 'CreditHistory',
    components: { IelTable, IelTableCell },

    data: () => ({
      url: '',
      search: '',
      headers: [
        { text: 'canal' },
        { text: 'Número cliente' },
        { text: 'Transacción ID' },
        { text: 'Tipo' },
        { text: 'Fecha solicitud' },
        { text: 'Razón social' },
        { text: 'RFC' },
        { text: 'Estado' },
        { text: 'Estatus' },
        { text: 'Acciones' },
      ],
      statusId: null,
      showResendModal: false,
      requestToResend: null,
      resendLoading: false,
    }),

    computed: {
      ...mapGetters('customersrequest', {
        requests: 'allRequests',
        pagination: 'pagination',
        customerstatus: 'customerstatus',
      }),
    },

    watch: {
      'pagination.page'(value) {
        this.loadData(value);
      },
    },

    mounted() {
      this.url = this.$filesUrl;
      this.debounceFn = debounce(() => this.loadData(1, this.search), 800);
      this.loadData(1);
      this.loadCustomerStatus();
    },

    methods: {
      ...mapMutations({
        setPage: 'customersrequest/SET_PAGE',
      }),
      ...mapActions('customersrequest', [
        'loadCustomerRequest',
        'loadCustomerStatus',
        'resendEmail',
      ]),
      ...mapActions('downloadJobs', ['requestExport']),
      onKeyup() {
        this.debounceFn();
      },
      loadData(page, search = '') {
        this.loadCustomerRequest({ status: this.statusId, search, page });
      },
      goToDetail(customerId) {
        this.$router.push(`/credit/customers-request/${customerId}`);
      },
      clearSearch() {
        this.setPage(1);
        this.loadData(1);
      },
      filterStatus() {
        this.loadCustomerRequest({
          status: this.statusId,
          search: null,
          page: 1,
        });
      },
      confirmResendEmail(request) {
        this.requestToResend = request;
        this.showResendModal = true;
      },
      closeResendModal() {
        this.showResendModal = false;
        this.requestToResend = null;
        this.resendLoading = false;
      },
      async onConfirmResendEmail() {
        if (!this.requestToResend) return;
        this.resendLoading = true;
        try {
          await this.resendEmail(this.requestToResend.live_uuid);
          this.$toast.success('Correo enviado');
          this.closeResendModal();
        } catch (_) {
          this.$toast.error(
            'Error al enviar el correo, por favor revise sus datos'
          );
        } finally {
          this.resendLoading = false;
        }
      },
      async requestExportAndNotify() {
        try {
          await this.requestExport({
            status: this.statusId,
            search: this.search,
          });
          this.$toast.success(
            'La exportación se está generando en segundo plano. Puede consultar el estado en Mis descargas.'
          );
        } catch (err) {
          this.$toast.error(
            err?.response?.data?.message || 'Error al solicitar la exportación'
          );
        }
      },
    },
  };
</script>
